export { default as default } from './KitCopyrightLogo';
